import { useTranslation } from "react-i18next";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";

export default function Privacy() {
    const { t } = useTranslation();
    return (
        <>
            <SEO title="Privacy Policy | Exportfy.world" description="Exportfy.world privacy policy — how we handle inquiry, sourcing, consultation, and newsletter data." path="/privacy" />
            <PageHero eyebrow={t("legal.hero.eyebrow")} title={t("legal.hero.title")} subtitle={t("legal.hero.subtitle")} />
            <section className="section-y">
                <div className="container-x max-w-3xl prose prose-slate">
                    <h2 className="text-2xl font-bold text-[#0A2540]">{t("legal.privacy.sections.data.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.privacy.sections.data.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.privacy.sections.usage.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.privacy.sections.usage.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.privacy.sections.retention.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.privacy.sections.retention.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.privacy.sections.rights.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.privacy.sections.rights.description")} <a className="text-[#1D4ED8] font-semibold" href="mailto:hello@exportfy.world">hello@exportfy.world</a>.</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.privacy.sections.cookies.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.privacy.sections.cookies.description")}</p>
                </div>
            </section>
        </>
    );
}
